<template>
  <CommonPages id="libray" classs="libray ">
    <div class="library-container pc_padding">
      <div class="site-title m-b-30 m-t-50">
        Library
      </div>
      <div class="library-tag-row">
        <div v-for="(data,i) in tagList" :key="`tag_${i}`" class="library-tag-item cursor"
          :class="{'active':activeTag == data}" @click="seclecTag(data)">
          {{ data }}
        </div>
      </div>

      <div class="library-row pc_padding">
        <div v-for="(data,i) in novelList" :key="`lib-${i}`" class="library-item cursor"
          @click="chooseNoval(data.novelId,data.id,data.novelName)">
          <div class="library-item-img-row">
            <div class="library-item-img-shadow" />
            <img :src="data.bigImg" class="library-item-img" alt="">
            <div class="library-item-info-stars-row">
              <img src="@/assets/star.png" alt=""> {{ data.novelScore }}/10
            </div>
          </div>
          <div class="library-item-title" v-html="data.novelName" />
          <div class="library-item-autor" v-html="data.novelAuthorName" />
          <div class="library-item-type">
            <div class="library-type" v-html="data.novelType" />
          </div>
        </div>
      </div>
    </div>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js';
import adMixin from '@/mixin/adMixin.js';
import adTrackingMixin from '@/mixin/adTrackingMixin.js';
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/pc_common.vue'

import '@/css/common.scss';

export default {
  name: 'Home',
  components: {
    CommonPages,
  },
  mixins: [common, adMixin, adTrackingMixin], 
  data () {
    return {
      novelList: [],
      tagList: null,
      recommondList: [],

      page: 1,   // 当前页数
      hasNext: false,
      activeTag: null,

    };
  },
  metaInfo () {
    return {
      title: `Library | ${this.domainConfig["IAmURL"]}`,
      meta: [
        {
          name: 'description',
          content: `Discover a world of AI-generated novels and stories at ${this.domainConfig["IAmURL"]}. Dive into unique, imaginative tales created by advanced artificial intelligence. Perfect for readers seeking fresh and innovative content.`,
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "adsensConfig",
      'adPosConfig',
      "domainConfig"
    ])
  },
  async activated () {
    console.log(`${this.$options.name} Component activated-----------`);
  },
  async mounted () {
    console.log(`-------------------${this.$options.name} mounted`)
    // this.loadAdSenseScript();  // 重新加载广告脚本
    this.getTagList()
    this.getPageList()

    // 使用防抖包装滚动事件
    this.onScroll = this.debounce(this.onScroll.bind(this), 300);
    // 监听滚动事件
    window.addEventListener('scroll', this.onScroll);
  },
  deactivated () {
    console.log(`${this.$options.name} Component deactivated-----------`);
  },
  beforeDestroy () {
    console.log(`-------------------${this.$options.name} beforeDestroy`);
    // 组件销毁时移除滚动事件监听
    // window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    //shuju
    async getTagList () {
      try {
        const res = await this.$global.server.getTagList({ noveLang: 'en' })
        console.log(res)
        this.tagList = res.data

      } catch (err) {
        console.log(err)
      }
    },
    async getPageList () {
      const params = {
        novelLang: 'en',
        pageNum: this.page,
        pageSize: 30,
      };
      // 只有当 this.tag 不为 null 时，才添加 tag 字段
      if (this.activeTag !== null) {
        params.novelType = this.activeTag;
      }

      try {
        const res = await this.$global.server.getPageList(params)
        console.log(res)
        if (res.code == 200) {
          let data = res.data.novelList
          this.novelList.push(...data)
          this.hasNext = res.data.hasNext
          this.page++;
        }
      } catch (err) {
        console.log(err)
      }
    },
    seclecTag (tag) {
      if (this.activeTag == tag) return
      console.log(tag);
      this.activeTag = tag
      this.page = 1;   // 当前页数
      this.hasNext = false;
      this.novelList = []
      this.getPageList()
    },
    chooseNoval (name, id) {
      console.log(name, id);
      const currentParams = this.$router.currentRoute.params; // 当前路由的 params
      const currentQuery = this.$route.query; // 当前路由的 query

      const channel = currentParams.channel ? `/${currentParams.channel}` : ''; // 拼接 channel path
      const queryString = new URLSearchParams(currentQuery).toString(); // 转换 query 对象为字符串
      const fullQueryString = queryString ? `?${queryString}` : ''; // 如果有查询参数，拼接为 ?xxx=yyy 格式

      window.location.href = `${channel}/${name}/${id}/0${fullQueryString}`;
      // window.location.href = `/${name}/${id}/0`
    },
    // 防抖函数
    debounce (func, delay) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    },
    onScroll () {
      // 获取文档的总高度
      const documentHeight = document.documentElement.scrollHeight;
      // 当前滚动的高度
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      // 视口的高度
      const windowHeight = window.innerHeight;

      // 当滚动距离接近底部2000px时触发
      if (scrollTop + windowHeight >= documentHeight - 2000) {
        console.log('加载');
        this.getPageList();
      }
    },
    //广告相关start
    shouldInsertAd (index) {
      // 判断是否应该插入广告的位置
      const position = index + 1;
      const adIndex = this.adPosConfig.home.indexOf(position);

      /// 返回广告在 homeAD 中的索引，如果不在配置中则返回 -1
      return adIndex !== -1 ? adIndex : -1;
    },
    shouldDetailInsertAd (index) {
      // 判断是否应该插入广告的位置
      const position = index + 1;
      const adIndex = this.adPosConfig.detail.indexOf(position);

      /// 返回广告在 homeAD 中的索引，如果不在配置中则返回 -1
      return adIndex !== -1 ? adIndex : -1;
    },
    async loadAdSenseScript () {
      // 其他需要在初次加载时执行的操作
      // 先检查广告是否已经加载
      if (window.adsbygoogle && window.adsbygoogle.loaded) { // 检查广告是否已经加载
        console.log("Adsense script already loaded.");
        this.$eventrack('adscript_loaded', 'expose');
        this.loadAdWithDelay()
        return; // 如果已加载，直接返回
      }
      await this.loadScriptConditionally();
      this.setupIframeTracking()

    },
    setupIframeTracking () {
      // let _this = this;
      console.log('ready to track iframe');
      const iframes = document.querySelectorAll('iframe');
      const tracker = new this.IframeTracker(this);
      iframes.forEach((iframe) => {
        tracker.addIframe(iframe, (iframeElement) => {
          console.log('Iframe 点击触发了!', iframeElement);
          const adContainer = iframeElement.closest('ins.adsbygoogle');

          if (adContainer) {
            // 获取父级 ins 元素的边界矩形
            const insRect = adContainer.getBoundingClientRect();

            // 计算父级 ins 元素相对于页面左上角的位置和高度
            const insX = insRect.left;
            const insY = insRect.top;
            const insHeight = insRect.height;

            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;

            let transformData = {
              insX: insX,
              insY: insY,
              insHeight: insHeight,
              windowWidth: windowWidth,
              windowHeight: windowHeight,
            }
            this.$adClick(JSON.stringify(transformData))
            
            tracker.trackEvent('ad_iframe_click', 'click', {
              'data-ad-slot': adContainer.dataset.adSlot,
            });
            
            // Facebook ViewContent事件追踪
            this.trackFacebookViewContent(adContainer.dataset.adSlot, transformData);
          }
        });
      });
    },
    IframeTracker: class {
      constructor(vues, resolution = 200) {
        this.vues = vues; // 保存 Vue 实例
        this.resolution = resolution;
        this.iframes = [];
        this.interval = null;
        this.activeIframe = null; // 存储最近被点击的iframe
        this.setupVisibilityTracking();
      }

      addIframe (element, callback) {
        const adContainer = element.closest('ins.adsbygoogle');
        const iframe = {
          element: element,
          callback: callback,
          hasTracked: false,
          adSlot: adContainer ? adContainer.dataset.adSlot : null,
        };
        this.iframes.push(iframe);

        if (!this.interval) {
          this.interval = setInterval(() => this.checkClick(), this.resolution);
        }
      }

      checkClick () {
        const activeElement = document.activeElement;
        if (activeElement) {
          this.iframes.forEach((iframe) => {
            if (activeElement === iframe.element && !iframe.hasTracked) {
              iframe.callback(iframe.element);
              iframe.hasTracked = true;
              this.activeIframe = iframe; // 更新最近被点击的iframe
            }
          });
        }
      }

      setupVisibilityTracking () {
        const hiddenProperty =
          'hidden' in document ? 'hidden' : 'webkitHidden' in document ? 'webkitHidden' : 'mozHidden' in document ? 'mozHidden' : null;
        const visibilityChangeEvent = hiddenProperty.replace(/hidden/i, 'visibilitychange');

        const onVisibilityChange = () => {
          if (!document[hiddenProperty]) {
            console.log('页面激活状态,返回页面?');
            this.activeIframe = null; // 重置最近被点击的iframe记录
          } else {
            console.log('页面非激活状态');

            if (this.activeIframe) {
              // 上报逻辑
              this.trackEvent('ad_iframe_click_leave', 'click', {
                'data-ad-slot': this.activeIframe.adSlot,
              });
            }
          }
        };

        this.iframeVisibilityTracker = onVisibilityChange;
        document.addEventListener(visibilityChangeEvent, this.iframeVisibilityTracker);
      }

      trackEvent (eventName, eventValue, dataAttributes) {
        // 事件追踪逻辑
        console.log(`${eventName} with value ${eventValue} on`, dataAttributes);

        this.vues.$eventrack(eventName, eventValue, {
          ...dataAttributes,
        });
      }
    },
    trackFacebookViewContent (adSlot, transformData) {
      // 检查是否有Facebook像素配置
      const facebookConfig = this.$store.state.hostInject?.facebook;
      if (!facebookConfig || !facebookConfig.pixelId) {
        console.log('Facebook pixel not configured for this domain');
        return;
      }
      
      // 构建ViewContent事件数据
      const contentData = {
        content_type: 'advertisement',
        content_ids: [adSlot],
        content_name: `Ad Slot ${adSlot}`,
        content_category: 'advertisement',
        currency: 'USD',
        ad_position: {
          x: transformData.insX,
          y: transformData.insY,
          height: transformData.insHeight
        },
        viewport_size: {
          width: transformData.windowWidth,
          height: transformData.windowHeight
        }
      };
      
      // 触发Facebook ViewContent事件
      this.$fbViewContent(contentData);

    },
    loadScriptConditionally () {
      console.log(this.adsensConfig);
      // 判断广告脚本URL是否存在
      if (!this.adsensConfig?.scriptUrl) {
        console.log('广告脚本的URL不存在,终止加载广告外链');
        this.$eventrack('no_adscript_config', 'expose');
        return;
      }
      // 检查该脚本是否已经被添加
      const existingScript = document.querySelector(`script[src="${this.adsensConfig?.scriptUrl}"]`);
      if (existingScript) {
        this.$eventrack('adscript_exist', 'expose');
        console.log('脚本已存在，无需重新添加');
        return;
      }

      console.log('准备插入脚本');
      const script = document.createElement('script');
      script.src = this.adsensConfig?.scriptUrl;
      script.crossOrigin = 'anonymous';
      script.async = true;

      const header = document.getElementsByTagName('head')[0];
      header.appendChild(script);

      this.$eventrack('adscript_add_success', 'expose');
      script.onload = this.loadAdWithDelay.bind(this); // 使用 bind 确保 this 指向正确
      console.log('脚本插入完成,加载完成,执行加载插入广告及监听操作');

    },
    loadAdWithDelay () {
      setTimeout(() => {
        this.displayAd('ads-');
      }, 500);
    },
    async displayAd (tag) {
      await this.$nextTick();

      // 获取所有 ads 元素的 refs，过滤掉非广告的 ref
      const adsElements = Object.entries(this.$refs)
        .filter(([key, ref]) => key.startsWith(tag) && ref !== undefined) // 排除 undefined 的 refs
        .flatMap(([, ref]) => ref); // 展开并获取所有元素

      if (!window.adsbygoogle || !window.adsbygoogle.loaded) {
        console.log("Adsense script not loaded yet, delaying ad display.");
        setTimeout(this.displayAd, 500); // 延迟再次尝试
        return;
      }

      console.log(adsElements); // 检查是否包含 <ins> 标签
      adsElements.forEach(ad => {
        console.log(ad); // 输出每个广告元素
        console.log('ready to push');
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      });
    },
    //广告相关end

    //ciyi

    goto (name) {
      this.$router.push({ name: name });
    },

  }
};
</script>
